import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Views } from "react-big-calendar";
import dayjs from "dayjs";
import { formatIsoDate } from "@/utils/date-format";
import { RESOURCE_CALENDAR_VIEW_KEYS } from "./resourceCalendarTimeGridDefaults";

/** Persist default view/date in the URL so calendar state does not drift while idle. */
export function useSyncResourceCalendarSearchParams(isMobile: boolean) {
  const [searchParams, setSearchParams] = useSearchParams();
  const didSyncRef = useRef(false);

  useEffect(() => {
    if (didSyncRef.current) return;
    didSyncRef.current = true;

    const rawView = searchParams.get("view");
    const rawDate = searchParams.get("date");
    const needsView = !rawView || !RESOURCE_CALENDAR_VIEW_KEYS.has(rawView);
    const needsDate = !rawDate || !dayjs(rawDate).isValid();
    if (!needsView && !needsDate) return;

    const next = new URLSearchParams(searchParams);
    if (needsView) {
      next.set("view", String(isMobile ? Views.DAY : Views.MONTH));
    }
    if (needsDate) {
      next.set("date", formatIsoDate(dayjs()));
    }
    setSearchParams(next, { replace: true });
  }, [isMobile, searchParams, setSearchParams]);
}
